import { Injectable } from '@angular/core';
import { CustomHttpService } from '@services/generals/custom-http.service';
import { AbstractService } from "@services/abstract.service";
import { DocumentTypeClass } from "@classes/document-type.class";

@Injectable({providedIn: 'root'})
export class DocumentTypeService extends AbstractService {
    constructor(
        public customHttpService: CustomHttpService,
    ) {
        super(customHttpService, new DocumentTypeClass());
        this.version = 'v1';
    }

  /** Función que inserta el Modelo */
  public create = () => {
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpPOST(
          true,
          true,
          url + this.modelClass.modelName,
          self.modelClass.getJsonBase()
        ).then(
          (response) => {
            if (response === false) { resolve(response); }
            resolve(true);
          }
        );
      }
    );
  }

  public getAllActive(): Promise<any>{
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName + '/GetActiveDocumentTypes').then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response;
            resolve(true);
          }
        );
      }
    );
  }

  public getAll(): Promise<any>{
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName).then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response;
            resolve(true);
          }
        );
      }
    );
  }

  public getByID = (id: number) => {
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName + '/' + id).then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response['data'];
            self.modelClass.set(response['data']);
            resolve(true);
          }
        );
      }
    );
  }

}
